<template>
    <div v-if="rankachievement || appScoreData" class="achievement-wapper">
        <div v-if="!!rankachievement && rankachievement.sort">
            <div @click="jumptoRank">
                <div class="achievement-score-one">NO.{{ rankachievement.sort }}</div>
                <div class="achievement-tab">{{ rankachievement.tagRankName }}</div>
            </div>
        </div>
        <div v-if="!!score" @click="jumpToScore">
            <div class="achievement-score">{{ score }}</div>
            <div class="achievement-tab">游戏评分</div>
        </div>
        <div>
            <div class="achievement-score">{{ thirdTabNum }}</div>
            <div class="achievement-tab">{{ thirdTabText }}</div>
        </div>
    </div>
</template>

<script>
import {getQueryString} from '@/utils/url';
export default {
    props: {
        downloadNum: {
            type: String,
            required: false,
        },
        appScoreData: {
            type: Object,
            required: false,
        },
        rankachievement: {
            type: Object,
            required: false,
        },
        isNewStyle: {
            type: Number,
            required: false,
        },
        isReserveApp: {
            type: Boolean,
            default: false,
        },
        bookedNum: {
            type: String,
            default: '',
        },
        downloadUrl: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            score: '',
        };
    },
    computed: {
        thirdTabNum() {
            if ((this.isReserveApp || this.bookedNum) && !this.downloadUrl) {
                return this.bookedNum;
            }
            return this.downloadNum;
        },
        thirdTabText() {
            if ((this.isReserveApp || this.bookedNum) && !this.downloadUrl) {
                return '预约量';
            }
            return '下载量';

        },
    },
    created() {
        this.score = this.appScoreData.mark.score;
    },
    mounted() {
        this.$logger.click({
            value: 'achievement',
            ext: {
                id: this.appScoreData.package_name,
                ext: {
                    gameName: this.appScoreData.app_name,
                    gameId: this.appScoreData.app_id,
                    gameType: this.appScoreData.app_type,
                    moudleName: 'achievement',
                    position: ['rank', 'score', 'downloadNum'],
                    isNewStyle: this.isNewStyle,
                    sid: getQueryString('sid') || '',
                    srcId: getQueryString('srcid') || '',
                    channelid: getQueryString('channelid') || '',
                },
                pos: '',
            },
            network: this.$wifi ? 'wifi' : '4g',
        });
    },
    methods: {
        jumptoRank() {
            window.location.href = `${this.rankachievement.url5689H5}&isNewStyle=1`;
            this.$logger.click({
                value: 'achievement',
                ext: {
                    id: this.appScoreData.package_name,
                    ext: {
                        gameName: this.appScoreData.app_name,
                        gameId: this.appScoreData.app_id,
                        gameType: this.appScoreData.app_type,
                        moudleName: 'achievement',
                        isNewStyle: this.isNewStyle,
                        sid: getQueryString('sid') || '',
                        srcId: getQueryString('srcid') || '',
                        channelid: getQueryString('channelid') || '',
                    },
                    pos: 'rank',
                },
            });
        },
        jumpToScore() {
            this.$emit('toScore');
            this.$logger.click({
                value: 'achievement',
                ext: {
                    id: this.appScoreData.package_name,
                    ext: {
                        gameName: this.appScoreData.app_name,
                        gameId: this.appScoreData.app_id,
                        gameType: this.appScoreData.app_type,
                        moudleName: 'achievement',
                        isNewStyle: this.isNewStyle,
                        sid: getQueryString('sid') || '',
                        srcId: getQueryString('srcid') || '',
                        channelid: getQueryString('channelid') || '',
                    },
                    pos: 'score',
                },
            });
        },
    },
};
</script>

<style scoped lang="scss">
    @import "~@/common/style/mixin/utils";
    @import "~@/common/style/mixin/mixins";
    @import "~@/common/style/mixin/border";
    $design-width: 1242;
    .achievement-wapper {
        width: 1140px;
        height: 228px;
        background:#F8F8F8 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        border-radius: 27px;
        margin-top: 53px;
        margin-bottom: 49px;
        margin-left: 51px;
        .achievement-tab {
            font-family: PingFangSC-Regular;
            font-size: 36px;
            color: #858585;
            letter-spacing: 0;
            text-align: center;
            line-height: 36px;
            font-weight: 400;
        }
        .achievement-score-one {
            font-family: PingFangSC-Semibold;
            font-size: 48px;
            letter-spacing: 0;
            text-align: center;
            line-height: 48px;
            font-weight: 600;
            margin-bottom: 18px;
            color: #3388FF;
        }
        .achievement-score {
            font-family: PingFangSC-Semibold;
            font-size: 48px;
            letter-spacing: 0;
            text-align: center;
            line-height: 48px;
            font-weight: 600;
            margin-bottom: 18px;
            color: #333;
        }
    }
</style>